import * as React from 'react';
import cx from 'classnames';
import { LProps, withLocalization } from '../../utils/wrappers';
import { compose } from 'redux';

interface Props {
  fileInputID: string;
  videoInputID?: string;
  className?: string;
  disabled?: boolean;
  banner?: boolean;
  prompt?: string;
  heading?: React.ReactNode;
}

const bannerClassname = 'cc__image_uploader__add_banner';

const ImageUploadTrigger = ({
  t, fileInputID, videoInputID, prompt = '', className = '',
  disabled = false, banner = false, heading
}: LProps<Props>) => (
  <div
    className={cx('cc__image_uploader__add_photo', className, { disabled, [bannerClassname]: banner })}
  >
    {heading &&
      <div className="cc__image_uploader__heading" role="status">{heading}</div>
    }
    <div className="cc__image_uploader__pick_row">
      <button
        type="button"
        className="cc__image_uploader__pick_btn"
        disabled={disabled}
        onClick={() => document.getElementById(fileInputID) && document.getElementById(fileInputID).click()}
      >
        <img className="" src="/assets/add-photo.svg" alt="" aria-hidden="true" />
        {t('Add photo')}
      </button>
      {videoInputID &&
        <button
          type="button"
          className="cc__image_uploader__pick_btn"
          disabled={disabled}
          onClick={() => document.getElementById(videoInputID) && document.getElementById(videoInputID).click()}
        >
          <i className="fa fa-video-camera" aria-hidden="true" />
          {t('Add video')}
        </button>
      }
    </div>
    {prompt && <div className="cc__image_uploader__prompt">{prompt}</div>}
  </div>
);

export default compose(
  withLocalization('imageUploader')
)(ImageUploadTrigger) as React.SFC<Props>;
